// extracted by mini-css-extract-plugin
module.exports = {"root":"DetailNav_root__3ZQrZ","list":"DetailNav_list__3J8iV","link":"DetailNav_link__2gC7Q","active":"DetailNav_active__YIAiD","container":"DetailNav_container__1Z7_h"};